import { useQuery, UseQueryResult } from '@tanstack/react-query'

import { useSelectedProjectStore } from '@/components/entities/common/model/selected-project.store'

import { RequestsService } from '../lib/requests.service'
import { RequestStatus } from '../lib/requests.types'

export const REQUESTS_STATUSES = 'requests-statuses'

export const useRequestsStatuses = (
  isActive: boolean
): UseQueryResult<RequestStatus[]> => {
  const { selectedProjectId } = useSelectedProjectStore()

  return useQuery({
    queryKey: [REQUESTS_STATUSES, selectedProjectId],
    queryFn: () =>
      RequestsService.getRequestStatuses(selectedProjectId, isActive),
    select: response => response.data
  })
}
